<template>
    <div class="modal-access" >
        <div class="modal-access__wrapper">
            <div class="modal-access__header">
                <IconSpeaker class="modal-access__speaker" @click="speechSynthesis(text)"></IconSpeaker>
                <p class="modal-access__title">{{ text }}</p>
            </div>

            <p class="modal-access__subtitle">Wybrany przez Ciebie materiał jest przeznaczony dla starszych dzieci, jeśli chcesz go zobaczyć poproś rodzica&nbsp;o odblokowanie.</p>

            <div class="modal-access__btns">
                <div class="modal-access__btn modal-access__reject" @click="reject()">Anuluj</div>
                <div class="modal-access__btn modal-access__confirm" @click="unlock()">Odblokuj</div>
            </div>

            <IconClose class="modal-access__close close" @click="reject()"></IconClose>
        </div>
    </div>
</template>

<script>
// import Image from "../elements/Image.vue";
import IconClose from "../elements/icons/IconClose.vue";
import IconSpeaker from "../elements/icons/IconSpeaker.vue";

export default {
    name: "ModalUnlock",
    props: {
        itemId: {
            type: Number
        },
        path: {
            type: String
        }
    },
    data() {
        return {
            showModal: false,
            text: "Poproś rodzica o odblokowanie"
        };
    },
    components: {
        // Image,
        IconClose,
        IconSpeaker
    },
    methods: {
        reject() {
            this.$store.dispatch("changeModalUnlock", false);
            this.$store.dispatch("changeModalBackdrop", false);
            this.$emit("closeModalUnlock", true);
        },
        unlock() {
            this.$store.dispatch("changePinLock", { isOpen: true, id: this.itemId, path: this.path, mode: 'unlock'});
            // this.$emit("closeModalUnlock");
        }
    },
    mounted() {
        this.$store.dispatch("changeModalUnlock", true);
    }
};
</script>
